<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row> 
      <v-col
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto'"
      >
        <span class="float-right">
          <v-menu
            v-if="mobile()"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-2"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            >
              <v-list-item
                class="accent--text"
                @click="showUsersStatus"
              >
                <v-list-item-title>{{ $t('userStatusItem') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showSettings">
                <v-list-item-title>{{ $t('settingsItem') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
        <p 
          :class="mobile() ? 'text-h5 font-weight-bold ml-16 mr-16' : 'text-h5 font-weight-bold'"
          :align="mobile() ? 'center' : 'left'"
        >
          {{ $t('settingsPlanday') }}
        </p>
      </v-col>
      <v-col
        v-if="!mobile()"
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? 'custom-tab-menu py-0' : 'mx-auto custom-tab-menu py-0'"
      >
        <v-list
          class="py-0"
          flat
        >
          <v-list-item
            class="accent--text"
            @click="showUsersStatus"
          >
            {{ $t('userStatusItem') }}
          </v-list-item> 
          <v-list-item @click="showSettings">
            {{ $t('settingsItem') }}
          </v-list-item> 
        </v-list> 
      </v-col>
    </v-row>
    <v-row v-if="!loadingData && integrationId">
      <v-col :cols="mobile() ? '12' : '11'" :class="mobile() ? '' : 'mx-auto'" align="right" style="position: relative;">
        <v-btn @click="syncUsers()" class="rounded-xxl mb-5 text-none" color="accent" :loading="loading" data-testid="sync-button">{{ $t('syncUsersBtn')}}</v-btn>
        <v-alert v-model="alertLimit" dismissible outlined prominent max-width="420px" align="left" color="error" class="alert-absolute rounded-lg ml-3">
          <span class="darktext--text">You have reached the maximum amount of users allowed on your plan. To add more users please contact us at <span class="accent--text">economy@skillboost.io</span></span>
        </v-alert>
        <v-card
          v-for="user in users"
          :key="user.id"
          rounded="xxl"
          class="my-2 solo"
        >
          <v-hover v-if="mobile()">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                sm="11"
                class="pl-5"
                align="left"
              >
                <v-card-text v-if="user.hasOwnProperty('is_synced')" class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                  {{ user.firstName }} {{ user.lastName }}
                </v-card-text>
                <v-card-text v-else class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                  {{ user.first_name }} {{ user.last_name }}
                </v-card-text>
                <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                  {{ user.email }}
                </v-card-text>
                <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate" data-testid="planday-status">
                  <span v-if="user.hasOwnProperty('is_synced')">
                    {{ user.is_space_member ?  $t('synchedStatus') : $t('notSynchedStatus') }}
                  </span>
                  <span v-else>
                    {{ $t('removedPlandayStatus') }}
                  </span>
                </v-card-text> 
              </v-col>
              <v-col
                sm="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        large
                        data-testid="threedots-icon"
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                cols="12"
                md="4"
                align="left"
                class="pl-5"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('name') }}
                </div>
                <div v-if="user.hasOwnProperty('is_synced')" class="text-body-1 darktext--text">
                  {{ user.firstName }} {{ user.lastName }}
                </div>
                <div v-else class="text-body-1 darktext--text">
                  {{ user.first_name }} {{ user.last_name }}
                </div>
              </v-col>

              <v-col
                cols="12"
                md="5"
                align="left"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('mail') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.email }}
                </div>
              </v-col>
              <v-col
                cols="12"
                md="2"
                align="left"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('status') }}
                </div>
                <div v-if="user.hasOwnProperty('is_synced')" class="text-body-1 darktext--text" data-testid="planday-status">
                  {{ user.is_space_member ?  $t('synchedStatus') : $t('notSynchedStatus') }}
                </div>
                <div v-else data-testid="planday-status">
                  {{ $t('removedPlandayStatus') }}
                </div>
              </v-col>      
              <v-col
                cols="12"
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        x-large
                        data-testid="threedots-icon"
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <Pagination
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="plandayInfo.total"
      :page-number="plandayInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
    />
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import { syncIntegrationUsers, getIntegrations, getIntegrationUsers } from "../../api/spaceApi";
import Pagination from '../../components/Pagination'


export default {
  components: {
    AlertMessages,
    Pagination
  },
  mixins: [repeatedMethodsMixin],

  data(){
    return{
      alertMsg:'',
      alertType:'',
      alertValue:false,
      integrationId: null,
      loadingData: false,
      loading: false,
      spaceId: window.$cookies.get("space_id"),
      users: [],
      alertLimit: false,
      plandayInfo: {
        currentPage: 1,
        total: 1,
      },
      pageNumber: 1,
      size: 15
    }
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  async created() {
    this.loadingData = true
    await this.fetchIntegrations()
    if(this.integrationId){
      await this.fetchUsers()
    }
    this.loadingData = false
  },
  methods:{
    handlePageChange(value){
      this.plandayInfo.currentPage = value
      this.pageNumber = value
      this.fetchUsers()
    },
    showUsersStatus(){
      this.$router.push({path: '/space/planday-users'})
    },
    showSettings(){
      this.$router.push({path: '/space/planday-settings'})
    },
    async fetchIntegrations() {
      try {
        const response = await getIntegrations(this.spaceId)
        if (response.status) {
          if (response.status == 200) {
            if (response.data.data.length > 0) {
              this.integrationId = response.data.data.find(item => item.attributes.name == 'planday' ).id
            }
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          }
          else if (e.response.status == 403) {
            this.$router.push({ name: 'PageAccessDenied' })
          } else {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },

    async fetchUsers() {
      try {
        const response = await getIntegrationUsers(this.integrationId, this.pageNumber, this.size)
        if (response.status) {
          if (response.status == 200) {
            this.users = response.data.meta[0].data
            this.plandayInfo = response.data.meta[0].paging
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          }
          else if (e.response.status == 403) {
            for(let i = 0; i < e.response.data.errors.length; i++){
              if(e.response.data.errors[i].detail == 'invalid_client'){
                  this.alertValue = true;
                  this.alertType = "error";
                  this.alertMsg = i18n.t("testPlandayIntegrationError");
              }
              else if(e.response.data.errors[i].detail == 'invalid_grant'){
                  this.alertValue = true;
                  this.alertType = "error";
                  this.alertMsg = i18n.t("testPlandayIntegrationError");
              }
              else {
                  this.$router.push({name: 'PageAccessDenied'})
              }
            }
          } else {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },

    async syncUsers() {
      this.loading = true;
      try {
        const response = await syncIntegrationUsers(this.integrationId)
        if (response.status) {
          if (response.status == 200) {
            await this.fetchUsers()
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          }
          else if (e.response.status == 403) {
            for(let i = 0; i < e.response.data.errors.length; i++){
              if(e.response.data.errors[i].detail == 'memberLimitReached'){
                this.alertLimit = true
                this.fetchUsers()
              }
              else if(e.response.data.errors[i].detail == 'invalid_client'){
                  this.alertValue = true;
                  this.alertType = "error";
                  this.alertMsg = i18n.t("testPlandayIntegrationError");
              }
              else {
                  this.$router.push({name: 'PageAccessDenied'})
              }
            }
          } else {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
      this.loading = false;
    },
  }
}
</script>
